"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProvider = exports.setCancelParameters = exports.setAppointment = void 0;
exports.setAppointment = '@action/SET_APPOINTMENT';
exports.setCancelParameters = '@action/SET_CANCEL_PARAMETERS';
exports.setProvider = '@action/SET_PROVIDER';
//# sourceMappingURL=Actions.js.map